module.exports = __webpack_public_path__ + "static/media/nutridos.e32fa199.jpeg";